export default `angielski chyby angielski przeźmierowo angielski rokietnica angielski sady angielski
smochowice angielski baranowo angielski kiekrz nauka angielskiego chyby nauka angielskiego przeźmierowo nauka
angielskiego rokietnica nauka angielskiego sady nauka angielskiego smochowice nauka angielskiego baranowo nauka
angielskiego kiekrz szkoła językowa chyby szkoła językowa przeźmierowo szkoła językowa rokietnica szkoła językowa sady
szkoła językowa smochowice szkoła językowa baranowo szkoła językowa kiekrz`;
